import { useNavigate } from '@tanstack/react-router';
import { Button, Card, Group, SimpleGrid, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconArrowRight, IconBuildingWarehouse } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../shared/components/PageHeader';
import { useAuth } from '../auth/useAuth';

/**
 * Post-login landing. A light dashboard placeholder — a greeting plus quick
 * entry points to the workflows as they come online. Real dashboard widgets
 * (inventory KPIs, etc.) land later.
 */
export function AppHomeRoute() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <>
      <PageHeader
        title={t('appHome.greeting', { name: user?.displayName ?? '' })}
        subtitle={t('appHome.subtitle')}
      />
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }} spacing="md">
        <Card withBorder radius="md" padding="lg">
          <Stack gap="sm">
            <Group gap="sm">
              <ThemeIcon variant="light" color="invetrak" size="lg" radius="md">
                <IconBuildingWarehouse size={20} />
              </ThemeIcon>
              <Text fw={600}>{t('nav.warehouses')}</Text>
            </Group>
            <Text size="sm" c="dimmed">{t('appHome.warehousesBlurb')}</Text>
            <Button
              variant="light"
              color="invetrak"
              rightSection={<IconArrowRight size={16} />}
              onClick={() => navigate({ to: '/app/warehouses' })}
            >
              {t('appHome.openWarehouses')}
            </Button>
          </Stack>
        </Card>
      </SimpleGrid>
    </>
  );
}
